import React from 'react';
import { FormControl, FormHelperText, FormGroup, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { ENVIRONMENT_OPTIONS, DEVELOPER_ENVIRONMENT_OPTIONS } from '../const';
import { AccountUsageType } from '../types';

interface EnvironmentFieldProps {
  value: string[];
  onChange: (value: string, checked: boolean) => void;
  accountUsage: AccountUsageType;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

export const EnvironmentField = ({
  value,
  onChange,
  accountUsage,
  error,
  errorMessage,
  disabled,
}: EnvironmentFieldProps) => (
  <FormControl 
    disabled={disabled}
    margin="normal" 
    required 
    error={error} 
    fullWidth
  >
    <Typography variant="h6">
      Environments
    </Typography>
    <FormGroup>
      {(accountUsage === AccountUsageType.Developer ? DEVELOPER_ENVIRONMENT_OPTIONS : ENVIRONMENT_OPTIONS).map((option) => (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={value.includes(option.value)}
              onChange={(e) => onChange(option.value, e.target.checked)}
            />
          }
          label={option.label}
        />
      ))}
    </FormGroup>
    <FormHelperText error={false}>
      Select the environments for account creation. At least one environment must be selected.
    </FormHelperText>
    {errorMessage && (
      <FormHelperText error>{errorMessage}</FormHelperText>
    )}
  </FormControl>
); 